import React from 'react';

export const NewsCard = ({ article, onClick, variant = 'default' }) => {
  const isFeatured = variant === 'featured';
  
  return (
    <article 
      className={`news-card cursor-pointer group ${isFeatured ? 'p-0' : 'p-4 md:p-6'}`}
      onClick={() => onClick(article)}
      data-testid={`news-card-${article.id}`}
    >
      <div className={`${isFeatured ? 'h-full flex flex-col' : ''}`}>
        {/* Image */}
        <div className={`news-image-container ${isFeatured ? 'flex-1 min-h-[300px] md:min-h-[400px]' : 'aspect-[16/10] mb-4'}`}>
          <img 
            src={article.image_url} 
            alt={article.title}
            className="w-full h-full object-cover"
            loading="lazy"
            data-testid={`news-image-${article.id}`}
          />
        </div>
        
        {/* Content */}
        <div className={`${isFeatured ? 'p-6 md:p-8 bg-white' : ''}`}>
          {/* Category */}
          <span 
            className="category-badge block mb-2"
            data-testid={`news-category-${article.id}`}
          >
            {article.category}
          </span>
          
          {/* Title */}
          <h3 
            className={`font-heading font-bold leading-tight mb-2 group-hover:underline ${
              isFeatured 
                ? 'text-2xl md:text-3xl lg:text-4xl' 
                : 'text-lg md:text-xl'
            }`}
            data-testid={`news-title-${article.id}`}
          >
            {article.title}
          </h3>
          
          {/* Excerpt */}
          <p 
            className={`text-gray-600 font-body ${isFeatured ? 'text-base md:text-lg line-clamp-3' : 'text-sm line-clamp-2'}`}
            data-testid={`news-excerpt-${article.id}`}
          >
            {article.excerpt}
          </p>
          
          {/* Date */}
          <time 
            className="block mt-3 text-sm text-gray-500 font-mono"
            data-testid={`news-date-${article.id}`}
          >
            {article.date}
          </time>
        </div>
      </div>
    </article>
  );
};

export default NewsCard;
